import React, { useState, useEffect } from 'react';

import { Dialog, Card } from '@mui/material';
import { images, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import NewButton from '../Buttons/NewButton';

const ShowLocationsModal = (props) => {
    const MOBILE = useIsMobile();
    const [show, setShow] = useState(props.show)
    const { t } = useTranslation();

    const handleClose = () => {
        props.onClose()
      //  setShow(false)
    }
    useEffect(() => {
        setShow(props.show)
    },[props.show])

    const openExternal = () => {
        const url = "https://maps.google.com/?q=" + props.address;
        window.open(url, "_blank");
    }
    
    return(
        <>
        <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
            <Card className="settings-dialog d-flex flex-column scrollable-y">
                <div className="w-100 h-100">
                    <div className="p-3 grey-blue">
                        <div className="d-flex flex-row justify-content-between align-items-center">
                            <div className='d-flex align-items-center'>
                                <h3 className="">{t("settings.open_link")}</h3>
                            </div>
                            <img className="cursor-pointer" src={icons.close_gray} onClick={() => props.onClose()} alt="..." /> 
                        </div>
                        <p className="grey-blue py-3">{t("settings.open_external")}</p>

                        <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                            <NewButton onClick={() => props.onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                            <NewButton onClick={() => openExternal()} className="bg-gradient p-3 rounded24 w-100 white body bold ms-2">{t("settings.open")}</NewButton>
                        </div>
                    </div>
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default ShowLocationsModal;